import { render } from "./index.vue?vue&type=template&id=7797ea49&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7797ea49"

export default script